import { User } from "../store/slices/User/reducer";
import { formatDate, normalizeText, phoneFormat } from "./string";

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
};

export enum UserRole {
  ADMIN = 'ADMINISTRATOR',
  COLLABORATOR = 'COLLABORATOR',
  REVIEWER = 'REVIEWER',
};

export const getUserTypeLabel = (role: UserRole | undefined) => {
  switch (role) {
    case UserRole.ADMIN:
      return 'Administrador';
    case UserRole.COLLABORATOR:
      return 'Brigadista';
    case UserRole.REVIEWER:
      return 'Revisor';
    default:
      return 'No definido';
  }
};

export const getUserStatusLabel = (status: UserStatus) => {
  switch (status) {
    case UserStatus.ACTIVE:
      return 'Activo';
    case UserStatus.DISABLED:
      return 'Archivado';
    default:
      return 'No definido';
  }
};

export const filterUsersBySearch = (users: User[], search: string = '') => {
  if (!search) return users;
  const query = normalizeText(search);
  return users.filter((user) => {
    const fullName = `${user?.firstName} ${user?.lastName}`;
    return (
      normalizeText(fullName).includes(query) ||
      normalizeText(user.email).includes(query) ||
      normalizeText(user.phone).includes(query) ||
      normalizeText(getUserTypeLabel(user.role)).includes(query) ||
      normalizeText(getUserStatusLabel(user.status)).includes(query)
    );
  });
};

export const sortUsers = (users: User[], sortBy: string, sortDirection: string) => {
  if (!sortBy) return users;
  const sortedUsers = [...users];
  sortedUsers.sort((a, b) => {
    const aValue = a[sortBy as keyof User];
    const bValue = b[sortBy as keyof User];
    return `${aValue}`.localeCompare(`${bValue}`);
  });
  if (sortDirection === 'desc') sortedUsers.reverse();
  return sortedUsers;
};

export const formatUserName = (user: User | null) => {
  if (!user) return 'Usuario desconocido';
  return `${user?.firstName} ${user?.lastName}`;
};

export const formatExportUserData = (users: User[]) => {
  return users.map((user) => ({
    'Nombre': user?.firstName,
    'Apellido': user?.lastName,
    'Email': user?.email,
    'Teléfono': phoneFormat(user?.phone),
    'Rol': getUserTypeLabel(user?.role),
    'Estatus': getUserStatusLabel(user?.status),
    'Fecha de registro': formatDate(user?.createdAt),
    'Última actualización': formatDate(user?.updatedAt),
  }));
};
